<footer class="footer">
  <!-- footer logo -->
  <section class="footer__logo">
    <img
      class="logo-img"
      ngSrc="assets/icons/logo-wejoiner.svg"
      alt="weJoiner"
      height="160"
      width="160" />
  </section>
  <!-- footer menu -->
  <section class="footer__menu">
    <ul class="menu-pages">
      @for (page of pages1; track page.id) {
        <li class="menu-pages__item">
          <a [routerLink]="page.link">
            {{ page.name | translate }}
          </a>
        </li>
      }
    </ul>
    <ul class="social-media">
      @for (social of socialMedias; track social.id) {
        <li class="social-media__item">
          <!-- we set social icon image as background because we need set transition for that -->
          <a [href]="social.link">
            <div
              class="social-img"
              [style.backgroundImage]="
                hoveredSocialMediaId === social.id
                  ? 'url(' + social.iconHover + ')'
                  : 'url(' + social.icon + ')'
              "
              (mouseenter)="onIconHover(social.id)"
              (mouseleave)="onIconHoverFinish()"></div>
          </a>
        </li>
      }
    </ul>
    <ul class="categories">
      @for (category of pages2; track category.id) {
        <li class="categories__item">
          <a [routerLink]="category.link">
            {{ category.name | translate }}
          </a>
        </li>
      }
    </ul>
  </section>
  <!-- footer content -->
  <section class="footer__content">
    <p class="footer__allrights">
      {{ 'footer.allRightsReserved' | translate }}
    </p>
    <p class="footer__years">© {{ fullYear }} Wejoiner</p>
  </section>
</footer>
